module.exports = __webpack_public_path__ + "img/section4_img4.1675ee5e.svg";